<template>
  <div class="van-tabs-content item6">
    <img class="item6_bg" src="@/assets/img/item6_bg.png" alt="" />
    <div class="context-box" v-for="(item, index) in homeContent" :key="index">
      <img :src="item.ImgSrc" alt="" />{{ $t(item.label) }}
    </div>
  </div>
</template>

<script>
export default {
  name: "infoItem6",
  data() {
    return {
      homeContent: [
        {
          ImgSrc: require("@/assets/img/homePageImg01.png"),
          label: "briefInfo",
          path: "conferenceIntro",
          hide: false,
        },
        {
          ImgSrc: require("@/assets/img/homePageImg02.png"),
          label: "distribution",
          path: "distribution",
          hide: true,
        },
        {
          ImgSrc: require("@/assets/img/homePageImg03.png"),
          label: "agenda",
          path: "agenda",
          hide: false,
        },
        {
          ImgSrc: require("@/assets/img/homePageImg04.png"),
          label: "promotionalVideo",
          path: "promotionalVideo",
          hide: false,
        },
        {
          ImgSrc: require("@/assets/img/ucc_logo.png"),
          label: "",
          path: "",
        },
        {
          ImgSrc: require("@/assets/img/homePageImg06.png"),
          label: "website",
          path: "",
        },
        {
          ImgSrc: require("@/assets/img/homePageImg07.png"),
          label: "video",
          path: "video",
          hide: true,
        },
        {
          ImgSrc: require("@/assets/img/homePageImg08.png"),
          label: "album",
          path: "",
          hide: false,
        },
        {
          ImgSrc: require("@/assets/img/homePageImg09.png"),
          label: "partner",
          path: "cooperation",
          hide: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.van-tabs-content {
  margin: 32px 0 0;
  &.item6 {
    position: relative;
    .item6_bg {
      position: absolute;
      top: 36px;
      left: 50%;
      transform: translateX(-50%);
      width: 238px;
      height: 238px;
      object-fit: contain;
    }
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    margin: 40px 0;
    padding: 0 33px;
    width: 100%;
    box-sizing: border-box;
    .context-box {
      position: relative;
      display: flex;
      margin: 0 0 26px;
      margin-right: 43px;
      background-size: contain;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 64px;

      img {
        display: block;
        width: 64px;
        height: 64px;
        margin: 0 0 8px;
        object-fit: contain;
      }

      font-size: 12px;
      font-weight: 400;
      color: #fff;
      line-height: 17px;

      &:nth-child(3n + 1) {
        margin-right: 0;
      }
      &:nth-child(5) {
        margin-right: 36px;
      }
      &:nth-child(6) {
        margin-right: 36px;
        width: 78px;
        img {
          width: 78px;
          height: 80px;
        }
      }
    }
  }
}
</style>
